export const DATA_HOOKS = {
  LOADING_REVIEWS: 'loading-reviews',
  PAGINATION: 'pagination',
  INFINITE_SCROLL_CONTAINER: 'infiniteScroll-container',
  REVIEWS_CONTAINER: 'reviews-container',
  CUSTOM_HEADER: 'custom-header',
  ADD_REVIEW_BANNER: 'add-review-banner',
  CUSTOM_PAGINATION_WRAPPER: 'custom-pagination-wrapper',
  REVIEWS_PAGINATION_CONTAINER: 'reviews-pagination-container',
  REVIEWS_COLUMN: 'reviews-column',
  REVIEWS_SECTION: 'reviews-section',
  REVIEWS_TITLE: 'reviews-title',
  NO_REVIEWS_TEXT: 'no-reviews-text',
} as const;
